import React, { useState } from "react";
import { Drawer, message } from "antd";
import { generate_bank_account_report } from "../../services";
import PropTypes from "prop-types";
import { CircleAnimationCompact } from "../loading";
import { CashFlowTable } from "./components";
import { PdfReportReview } from "../reports";
import { BankIndividualReportTemplate } from "./banks_templates";
import { useBankAccountReportHook } from "./hooks";

export const BankAccountReport = ({
	token,
	company,
	bankAccountReportSelected,
	setBankAccountReportSelected,
}) => {		
	const [data, setData] = useState([]);
		
	const onSetData = (pData = []) => {
		if(pData.length === 0){
			message.info("No se encontraron registros");
			setDataToProcess([]);
		}
		
		setData(pData);
	};
	
	const {	
		dataToProcess,
		loading,
		openReviewInvoice,
		exchangeRate,
		isUSDActive,		
		currentYear,		
		ExchangeComponent,
		DownloadOptions,
		setDataToProcess,
		setOpenReviewInvoice,
		onClose,
	} = useBankAccountReportHook({
		token, 
		company, 
		bankAccountReportSelected, 
		setBankAccountReportSelected,
		searchType: "status",
		elementsToSearch: { bank_account_id: bankAccountReportSelected.id, },
		onSendData: onSetData,
	});
	
	const updatedBankAccount = {
		...bankAccountReportSelected,
		basePoints: (() => {
			const { initial_amount, basePoints } = bankAccountReportSelected;

			const basePointsList = Object.entries(basePoints)
				.sort((a, b) => new Date(a[0]) - new Date(b[0]))
				.map(entry => entry[0]);

			if(basePointsList.length === 0) return basePoints;

			const [year, month] = basePointsList[0].split("-");
			const monthToSet = month - 1 === 0 ? "12" : `${month - 1}`;
			const yearToSet = month - 1 === 0 ? year - 1 : year;

			return {
				[`${yearToSet}-${String(monthToSet).padStart(2, "0")}`]: initial_amount,
				...basePoints,
			};
		})(),
	};

	return (
		<Drawer
			title={`Reporte Cuenta Bancaria ${currentYear > 0 ? currentYear : ""} - ${bankAccountReportSelected?.account_number}`}
			placement="right"
			onClose={onClose}
			open={bankAccountReportSelected !== null}
			width={"100%"}
			extra={DownloadOptions}
		>
			{loading && <CircleAnimationCompact />}

			{!loading && <CashFlowTable
				data={data}
				currency={isUSDActive ? "$" : "Q"}
				originalCurrency={bankAccountReportSelected?.currency}
				exchangeRate={exchangeRate}
				isUSDActive={isUSDActive}				
				basePoints={{
					...updatedBankAccount.basePoints,
					...updatedBankAccount.temporalBasePoints,
					...bankAccountReportSelected.basePoints,
				}}
				bankAccounts={[updatedBankAccount]}
				currentYear={currentYear}
				onDataToSend={setDataToProcess}
				header={ExchangeComponent}
			/> }

			{open && 
				<PdfReportReview
					open={openReviewInvoice}
					content={dataToProcess}					
					renderContent={(dataMatrix) => <BankIndividualReportTemplate 
						dataMatrix={dataMatrix} 
						company={company} 
						bankAccount={bankAccountReportSelected}
						isUSDActive={isUSDActive}
						exchangeRate={exchangeRate}
						year={`${currentYear}`}
					/>}
					onSetOpen={setOpenReviewInvoice}
					onConfirmAction={() => generate_bank_account_report(
						dataToProcess,
						company, 
						bankAccountReportSelected?.account_number,
						isUSDActive ? "USD" : "GTQ",
						(dataMatrix) => <BankIndividualReportTemplate 
							dataMatrix={dataMatrix} 
							company={company} 
							bankAccount={bankAccountReportSelected}
							isUSDActive={isUSDActive}					
							exchangeRate={exchangeRate}
							year={`${currentYear}`}
						/>
					)}
					title={"Prevista del Reporte Individual antes de descargar"}
					confirmText={"Descargar"}
				/>
			}
		</Drawer>
	);
};

BankAccountReport.propTypes = {
	token: PropTypes.string.isRequired,
	company: PropTypes.shape({
		id: PropTypes.string.isRequired,
		name: PropTypes.string.isRequired,
		tid: PropTypes.string.isRequired,
	}).isRequired,
	bankAccountReportSelected: PropTypes.shape({
		id: PropTypes.string.isRequired,
		account_number: PropTypes.string.isRequired,
		bank: PropTypes.string.isRequired,
		initial_amount: PropTypes.number.isRequired,
		basePoints: PropTypes.object.isRequired,
		temporalBasePoints: PropTypes.object.isRequired,
		currency: PropTypes.string.isRequired,
	}).isRequired,
	setBankAccountReportSelected: PropTypes.func.isRequired,
};
